import React from 'react';
import ClassNames from 'classnames';
import Analytics from '../../services/analytics';
import PostHogService from '../../services/posthog';
import PostHogEvents from '../../constants/posthog-events';

import AppStore from '../../stores/stores';
import LoginStore from '../../stores/login-store';
import { browserHistory } from 'react-router';

export default class BookmarkButtonMarketing extends React.Component {
  constructor(props) {
    super(props);
    this.state = { bookmarked: !!props.bookmarked, visible: LoginStore.isLoggedIn() };
  }

  componentDidUpdate(prevProps) {
    if (prevProps.bookmarked !== this.props.bookmarked) {
      this.setState({ bookmarked: !!this.props.bookmarked });
    }
  }

  handleClick() {
    const { title, userApiRequest } = this.props;

    if (!this.state.bookmarked) {
      AppStore.storeBookmark(title, userApiRequest, {
        onSuccess: () => {
          this.setState({ bookmarked: true });
          Analytics.event('bookmark_add', { checklist_title: title });
          PostHogService.capture(PostHogEvents.BOOKMARK_ADDED, {
            title: title
          });
        },
        onError: () => { }
      });

      return;
    }

    AppStore.removeBookmark(title, userApiRequest, {
      onSuccess: () => {
        this.setState({ bookmarked: false });
        Analytics.event('bookmark_remove', { checklist_title: title });
        PostHogService.capture(PostHogEvents.BOOKMARK_REMOVED, {
          title: title
        });
      },
      onError: () => { }
    });
  }

  requestRegisterModal() {
    browserHistory.replace(`${window.location.pathname}?modal=register&restricted=1`)
  }

  render() {
    let value = (this.state.bookmarked) ? "Remove Bookmark" : "Bookmark Checklist";

    let classes = ClassNames({
      'bookmark-button': true,
      'bookmarked': this.state.bookmarked,
      'disabled': !this.state.visible
    });

    let icon = this.state.visible ? (
      this.state.bookmarked ? (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
        </svg>
      ) : (
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M19 21l-7-5-7 5V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2z"></path>
        </svg>
      )
    ) : (
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
        <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
      </svg>
    );

    return (
      <button className={classes} onClick={this.state.visible ? this.handleClick.bind(this) : this.requestRegisterModal.bind(this)}>
        {icon}
        <span>{value}</span>
      </button>
    )
  }
}
